module.exports = __webpack_public_path__ + "img/domastic-worker.017e8255.jpeg";